export default "__VITE_ASSET__BY5X60Ey__"